import React, { useEffect, useState } from "react";
import {
  ErrataWidget,
  Icon,
  WidgetFrame,
} from "../../../personal-studio-components/studio";
import { useSelector } from "react-redux";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import add_attachment from "./api";
import { StudentService } from "../../components/studentService";
import * as cls from "./sabbatical.module.scss";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";
import Loader from "../../components/loader/Loader";

function AcademicVacation() {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [isCalendarShow, setIsCalendarShow] = useState(false);
  const [reasons, setReasons] = useState(null);
  const [reasonId, setReasonId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDatesOffset, setStartDatesOffset] = useState(0);
  const [requiredDoc, setRequiredDocs] = useState(null);
  const [lastDayInSemester, setLastDayInSemester] = useState(new Date());
  const [data, setData] = useState(null);
  const [response, setResponse] = useState(null);
  const [isPageCountMatch, setIsPageCountMatch] = useState(false);
  const [defaultActiveStartDate, setDefaultActiveStartDate] = useState(
    new Date()
  );
  const [allowedStartDates, setAllowedStartDates] = useState([]);
  const [allowedEndDates, setAllowedEndDates] = useState([]);
  const [loadState, setLoadState] = useState(null);
  const [statementLoading, setStatementLoading] = useState(false);
  async function getCertificatesMenu() {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/academic/load",
        data: {
          access_token,
          study_contract_id: contractId,
        },
      };
      // const { data } = await axios("/k.json");
      const data = await StudentService.send(request, setResponse);
      if (!data.errors) {
        setResponse(data);
        const reasons = Object.values(data.reasons);
        setData(data);
        setReasons(reasons);
        setReasonId(reasons[0].document_reason_id);
        setRequiredDocs(Object.values(reasons[0].required_docs));
        setStartDatesOffset(data.start_dates_offset - 1);
        setLastDayInSemester(new Date(data.last_day_in_semester));
        const today = new Date();
        const allowedStartDates = getAllowedStartDates(data);
        setAllowedStartDates(allowedStartDates);
        const openDate = new Date();
        openDate.setDate(today.getDate() + data.start_dates_offset);
        setDefaultActiveStartDate(openDate);
        if (data.start_date && data.end_date) {
          setStartDate(new Date(data.start_date));
          setEndDate(new Date(data.end_date));
        }
      }
      setResponse(data);
    }
  }
  function getAllowedStartDates(data) {
    const today = new Date();
    // console.log(today, tmpDate);

    const arr = [];
    for (let i = data.start_dates_offset; i < data.start_dates_days; i++) {
      const futureDate = new Date();
      futureDate.setDate(today.getDate() + i);
      const dayOfWeek = futureDate.getDay();
      if (dayOfWeek !== 0) {
        arr.push(futureDate.toDateString());
      }
    }
    return arr;
  }
  function getAllowedEndDates(data) {
    const { last_day_in_semester, end_dates_years } = data;
    const lastDayInSemester = new Date(last_day_in_semester);

    const maxEndDate = new Date(startDate);
    maxEndDate.setFullYear(maxEndDate.getFullYear() + end_dates_years);
    const arr = [];
    let currentDate = new Date(Math.max(startDate, lastDayInSemester));
    while (currentDate < maxEndDate) {
      currentDate.setDate(currentDate.getDate() + 1); // Перемещаемся к следующему дню
      const dayOfWeek = currentDate.getDay();
      if (dayOfWeek !== 0 && currentDate > lastDayInSemester) {
        arr.push(currentDate.toDateString());
      }
    }
    return arr;
  }
  async function getStatement() {
    const { formattedDate, formattedDate2 } = fixDateFormat();

    if (access_token && startDate && endDate) {
      const request = {
        method: "post",
        path: "/student/applications/academic/statement",
        data: {
          access_token,
          study_contract_id: contractId,
          start_date: formattedDate,
          end_date: formattedDate2,
          reason_id: +reasonId,
        },
      };
      setStatementLoading(true);
      const res = await StudentService.send(request, (res) => {});
      if (!res.errors) {
        window.open(res.url);
      } else if (res.errors) {
        const errorEvent = new ErrorEvent("error", { error: res });
        window.dispatchEvent(errorEvent);
      }
      setStatementLoading(false);
    }
  }
  function fixDateFormat() {
    new Date().getDay();
    const year = startDate.getFullYear();
    const month = String(startDate.getMonth() + 1).padStart(2, "0"); // Месяцы 0-11, поэтому добавляем 1
    const day = String(startDate.getDate()).padStart(2, "0");
    const year2 = endDate.getFullYear();
    const month2 = String(endDate.getMonth() + 1).padStart(2, "0"); // Месяцы 0-11, поэтому добавляем 1
    const day2 = String(endDate.getDate()).padStart(2, "0");
    // console.log(startDate);
    const formattedDate = `${year}-${month}-${day}`;
    const formattedDate2 = `${year2}-${month2}-${day2}`;
    return { formattedDate, formattedDate2 };
  }
  useEffect(() => {
    getCertificatesMenu();
  }, []);

  function onStartDateChange(date) {
    setStartDate(date);
    setEndDate(null);
  }

  function onEndDateChange(date) {
    setEndDate(date);
    setIsCalendarShow(false);
  }
  const isStartDateAllowed = (date) => {
    return allowedStartDates.some((allowedDate) => {
      const allowed = new Date(allowedDate);
      return (
        date.getFullYear() === allowed.getFullYear() &&
        date.getMonth() === allowed.getMonth() &&
        date.getDate() === allowed.getDate()
      );
    });
  };
  const isEndDateAllowed = (date) => {
    return allowedEndDates.some((allowedDate) => {
      const allowed = new Date(allowedDate);
      return (
        date.getFullYear() === allowed.getFullYear() &&
        date.getMonth() === allowed.getMonth() &&
        date.getDate() === allowed.getDate()
      );
    });
  };

  // function tileDisabled({ date }) {
  //   const today = new Date();
  //   const disableFromDate = new Date(today);
  //   disableFromDate.setDate(today.getDate() + 180);

  //   const isSunday = date.getDay() === 0;
  //   return date > disableFromDate || isSunday;
  // }
  // function tileDisabled({ date }) {
  //   const today = new Date();
  //   const disableFromDate = new Date();
  //   let learningDaysOffset = 0;
  //   let daysCounted = 0;
  //   while (learningDaysOffset < startDatesOffset) {
  //     const dayOfWeek = disableFromDate.getDay();
  //     if (dayOfWeek >= 1 && dayOfWeek <= 6) {
  //       learningDaysOffset++;
  //     }
  //     daysCounted++;
  //   }
  //   disableFromDate.setDate(today.getDate() + daysCounted);
  //   const isSunday = date.getDay() === 0;
  //   return date <= disableFromDate || isSunday;
  // }

  // function endDateTileDisabled({ date }) {
  //   const isSunday = date.getDay() === 0;
  //   // return date < startDate;
  //   return date <= new Date(lastDayInSemester) || isSunday;
  // }

  const handleReasonChange = async (e) => {
    setReasonId(e.target.value);
    const selectedReason = reasons.find(
      (reason) => reason.document_reason_id == e.target.value
    );

    if (selectedReason?.required_docs) {
      setRequiredDocs(Object.values(selectedReason.required_docs));
    } else {
      setRequiredDocs([]);
    }
    setData((prev) => {
      return {
        ...prev,
        current_document_reason_id: +e.target.value,
      };
    });
  };

  const handleFileChange = async (event, doc) => {
    const newFiles = [...event.target.files];
    for (const file of newFiles) {
      const fileData = {
        access_token,
        study_contract_id: contractId,
        source_filename: file.name,
        file,
        progress_fn: (p) => {},
      };
      try {
        const res = await add_attachment(fileData);
        const updatedData = { ...data };
        let selectedReason = updatedData.reasons[reasonId];
        let updatedRequiredDocsArray = Object.values(
          selectedReason.required_docs
        ).map((docItem) => {
          if (docItem.doc_name_id === doc.doc_name_id) {
            return {
              ...docItem,
              uploaded_files: [...(docItem.uploaded_files || []), res],
            };
          }
          return docItem;
        });

        let updatedRequiredDocs = updatedRequiredDocsArray.reduce(
          (acc, docItem) => {
            acc[docItem.doc_name_id] = docItem;
            return acc;
          },
          {}
        );

        updatedData.reasons = {
          ...updatedData.reasons,
          [reasonId]: {
            ...selectedReason,
            required_docs: updatedRequiredDocs,
          },
        };
        let isPageCountMatch = pageCount();
        setIsPageCountMatch(isPageCountMatch);
        await saveState(false, updatedData);
        setData(updatedData);
        setRequiredDocs(
          Object.values(updatedData.reasons[reasonId].required_docs)
        );
      } catch (error) {
        console.error(error);
      }
    }
  };

  const removeFile = async (docNameId, filename) => {
    const updatedData = { ...data };
    let selectedReason = updatedData.reasons[reasonId];
    let updatedRequiredDocsArray = Object.values(
      selectedReason.required_docs
    ).map((doc) => {
      if (doc.doc_name_id === docNameId) {
        return {
          ...doc,
          uploaded_files: doc.uploaded_files.filter(
            (file) => file.filename !== filename
          ),
        };
      }
      return doc;
    });

    let updatedRequiredDocs = updatedRequiredDocsArray.reduce((acc, doc) => {
      acc[doc.doc_name_id] = doc;
      return acc;
    }, {});

    updatedData.reasons = {
      ...updatedData.reasons,
      [reasonId]: {
        ...selectedReason,
        required_docs: updatedRequiredDocs,
      },
    };
    let isPageCountMatch = pageCount();
    setIsPageCountMatch(isPageCountMatch);
    await saveState(false, updatedData);
    setData(updatedData);

    setRequiredDocs(Object.values(updatedData.reasons[reasonId].required_docs));
  };
  function pageCount() {
    let selectedReason = data.reasons[reasonId];
    let isPageCountMatch = Object.values(selectedReason.required_docs)
      .filter((doc) => doc.is_mandatory)
      .every((doc) => {
        return doc.uploaded_files.length >= doc.page_count_min;
      });

    return isPageCountMatch;
  }
  const saveState = async (bool = false, updatedData = data) => {
    let newData = { ...updatedData };
    if (access_token) {
      if (startDate && endDate) {
        const { formattedDate, formattedDate2 } = fixDateFormat();
        newData = {
          ...newData,
          start_date: formattedDate,
          end_date: formattedDate2,
        };
      }
      const request = {
        method: "post",
        path: "/student/applications/academic/save",
        data: {
          access_token,
          study_contract_id: contractId,
          state: {
            ...newData,
            complete: bool,
          },
        },
      };
      if (bool) setLoadState("loading");
      const res = await StudentService.send(request, (res) => {});
      if (!res.errors) {
        if (!bool) {
          setResponse(res);
          setData(res);
        }
        if (bool) {
          await getCertificatesMenu();
          setLoadState(null);
        }
        return true;
      } else {
        const errorEvent = new ErrorEvent("error", {
          error: res,
        });
        window.dispatchEvent(errorEvent);
        setLoadState("error");
        return false;
      }
    }
  };
  async function handleSaveState() {
    let isPageCountMatch = pageCount();
    if (isPageCountMatch) {
      const res = await saveState(true);
    }
  }
  useEffect(() => {
    if (data) {
      saveState();
    }
  }, [endDate]);
  useEffect(() => {
    if (data) {
      const allowedEndDates = getAllowedEndDates(data);
      setAllowedEndDates(allowedEndDates);
    }
  }, [startDate]);
  useEffect(() => {
    if (data) {
      let isPageCountMatch = pageCount();
      setIsPageCountMatch(isPageCountMatch);
    }
  }, [data, requiredDoc, response]);
  if (response?.errors) {
    if (response?.error_type !== "auth" && response?.error_type !== "info") {
      return <ErrataWidget errata={response} />;
    }
    if (response?.error_type === "info")
      return <ErrataViewInfo errata={response} />;
  }
  if (!response || !data) return null;

  return (
    <WidgetFrame
      type="blue"
      icon="survey"
      title="Личное заявление студента на отпуск"
    >
      Укажите период отпуска
      <div
        onClick={() => setIsCalendarShow((prev) => !prev)}
        className={cls.datePeriod}
      >
        {startDate && startDate.toLocaleDateString()} <Icon name="next_date" />
        {endDate && endDate.toLocaleDateString()}
      </div>
      {isCalendarShow && (
        <div style={{ display: "flex" }}>
          <div>
            <div style={{ marginBottom: "1rem" }}>Выберите начало отпуска</div>

            <Calendar
              selectRange={false}
              onChange={onStartDateChange}
              value={startDate}
              defaultActiveStartDate={defaultActiveStartDate}
              tileDisabled={({ date }) => !isStartDateAllowed(date)}
              // maxDate={new Date().setDate(new Date() + 180)}
            />
          </div>

          {startDate && (
            <div style={{ marginLeft: "1rem" }}>
              <div style={{ marginBottom: "1rem" }}>
                Выберите окончание отпуска
              </div>
              <Calendar
                selectRange={false}
                onChange={onEndDateChange}
                value={endDate}
                // tileDisabled={endDateTileDisabled}
                tileDisabled={({ date }) => !isEndDateAllowed(date)}
                defaultActiveStartDate={endDate || lastDayInSemester}
              />
            </div>
          )}
        </div>
      )}
      Основание ухода
      <select className={cls.datePeriod} onChange={handleReasonChange}>
        {reasons.map(({ document_reason_text, document_reason_id }) => (
          <option value={document_reason_id} key={document_reason_id}>
            {document_reason_text}
          </option>
        ))}
      </select>
      <div>
        {statementLoading ? (
          <Loader />
        ) : (
          <a
            className={startDate && endDate ? cls.sample : cls.sampleDisabled}
            onClick={startDate && endDate && getStatement}
            title={
              (!startDate || !endDate) && "Выберите даты начала и окончания"
            }
          >
            Шаблон заявления
          </a>
        )}
      </div>
      {/* {requiredDoc &&
        requiredDoc.map((el) => (
          <div key={el.doc_name_id}>
            {el.is_mandatory && <span className={cls.require}>*</span>}
            {el.doc_name}
          </div>
        ))} */}
      {requiredDoc &&
        requiredDoc.map((el, idx) => {
          return (
            <div key={`${el.doc_name_id}-${idx}`}>
              <div key={el.doc_name_id}>
                {el.is_mandatory && <span className={cls.require}>*</span>}
                {el.doc_name}
              </div>
              <input
                className={cls.inputHidden}
                id={`input__file-${el.doc_name_id}`}
                type="file"
                multiple
                onChange={(e) => handleFileChange(e, el)}
                accept="jpg"
              />
              <label
                className={cls.inputLabel}
                htmlFor={`input__file-${el.doc_name_id}`}
              >
                {el.uploaded_files[0]?.filename ? "Загрузить еще" : "Загрузить"}
              </label>
              <span className={el.is_mandatory && cls.require}>
                Мин. кол-во стр. &nbsp;{el.page_count_min}
              </span>
              {el.uploaded_files.map((file, i) => {
                return (
                  <div key={i} className={cls.uploadedFile}>
                    {file.filename}
                    <button
                      className={cls.removeFileButton}
                      onClick={() => removeFile(el.doc_name_id, file.filename)}
                    >
                      ✖
                    </button>
                  </div>
                );
              })}
            </div>
          );
        })}
      <div>
        {loadState === "loading" ? (
          <Loader />
        ) : (
          <button
            onClick={handleSaveState}
            className={`${
              isPageCountMatch ? cls.buttonBright : cls.buttonDisable
            }`}
            disabled={!isPageCountMatch}
          >
            Отправить
          </button>
        )}
      </div>
    </WidgetFrame>
  );
}

export default AcademicVacation;
